import angular from "angular";
import addChangeItemOptionDialogTemplate from "./AddChangeItemOptionDialog.template.html";

/*******************************************************************************
 * Service: AddChangeItemDiscountDialog
 *
 * This panel is used to create and modify <b>ItemDiscounts</b>. The discount
 * can be entered as a percentage that should be removed from the base item
 * price or as a discounted amount.
 *******************************************************************************/
/* @ngInject */ export function AddChangeItemOptionDialogService($uibModal, SERVER) {
  /*************************************************************************
   * Dialog Controller */
  /**
   * accounts, discount, itemPrice, addMode are injected from show
   * at modal open.
   *************************************************************************/
  var AddChangeItemOptionDialogController = function (
    $scope,
    Alert,
    Tools,
    addMode,
    allowPriceChange,
    optionMaster,
    optionMasterList,
    showQty
  ) {
    /** Old/New option flag */ $scope.addMode = addMode;
    /** Allow price change flag */ $scope.allowPriceChange =
      allowPriceChange;
    /** Current option */ $scope.optionMaster = optionMaster;
    /** Options list data provider */ $scope.optionMasterList =
      optionMasterList;
    /** Show quantity input */ $scope.showQty = showQty;
    /** Validator Object. */ $scope.validators = {};

    /*---------------------------------------------------*/
    /* Display tooltip when price change is not allowed. */
    /*---------------------------------------------------*/
    $scope.allowPriceChangett = !$scope.allowPriceChange
      ? 'This is not available for this item type.'
      : '';

    /*---------------------------*/
    /* Current option selection. */
    /*---------------------------*/
    var mOption = optionMaster;

    /*-----------*/
    /* UI Flags. */
    /*-----------*/
    $scope.enableValues = false;
    $scope.allowQtyChange = false;

    /*************************************************************************
     * addBtnLabel */
    /**
     * Returns text to display on the Add/Update button.
     *
     * @return  String  Text label
     *************************************************************************/
    $scope.addBtnLabel = function () {
      return addMode ? 'Add' : 'Update';
    };

    /*************************************************************************
     * disableAdd */
    /**
     * Returns an indication to disable the Add button. The Add button should be
     * disabled when no option has been selected, or when a Selected List option
     * is selected but no value is selected.
     *
     * @return  Boolean  True=disable button.
     *************************************************************************/
    $scope.disableAdd = function () {
      return (
        !$scope.optionMaster.type ||
        ($scope.optionMaster.type ==
          SERVER.BooksDBConstants.MOT_SELECTION_LIST &&
          !$scope.optionMaster.value)
      );
    };

    /*************************************************************************
     * getTitle */
    /**
     * Returns text to display for the modal title.
     *
     * @return  String  Display correct title for dialog.
     *************************************************************************/
    $scope.getTitle = function () {
      return $scope.addMode ? 'Add New Item Option' : 'Change Item Option';
    };

    /*************************************************************************
     * handleAll */
    /**
     * Add All Values button click event handler. Closes the dialog and sends all
     * values for the option back.
     *************************************************************************/
    $scope.handleAll = function () {
      /*------------------------------------------*/
      /* Create an item option for each of the    */
      /* available values of the selected option. */
      /*------------------------------------------*/
      var i = [];
      angular.forEach($scope.selectedOption().values, function (value) {
        var itemOption = {};

        itemOption.optionID = $scope.selectedOption().id;
        itemOption.value = value;
        itemOption.priceChange = 0;
        itemOption.qtyChange = 0;
        itemOption.optionName = $scope.selectedOption().name;
        itemOption.active = true;

        //itemOption.id          = 0;
        //itemOption.itemID      = 0;

        i.push(itemOption);
      });

      /*--------------------------------------------------------*/
      /* Close the dialog and resolve with the list of options. */
      /*--------------------------------------------------------*/
      $scope.$close(i);
    };

    /*************************************************************************
     * handleCommit */
    /**
     * Commit button click event handler. If data is valid close the dialog and
     * send back the new/modified item option.
     *************************************************************************/
    $scope.handleCommit = function () {
      /*------------------------------------*/
      /* Clear alerts and reset validators. */
      /*------------------------------------*/
      Alert.clear();
      $scope.validators.reset();

      /*------------------*/
      /* Validate inputs. */
      /*------------------*/
      if (!$scope.validators.validate()) return;

      /*-------------------------------------*/
      /* No option selected, alert and exit. */
      /*-------------------------------------*/
      if (!$scope.optionMaster.type) {
        Alert.error('Please select an Option to add.');
        return;
      }

      /*----------------------------------------*/
      /* Alert user if required value is empty. */
      /*----------------------------------------*/
      if (
        !$scope.optionMaster.value &&
        $scope.optionMaster.type ==
          SERVER.BooksDBConstants.MOT_SELECTION_LIST
      ) {
        Alert.error("Cannnot add a 'Selected List' option without values.");
        return;
      }

      /*------------------------------------------*/
      /* Close the dialog and resolve with a list */
      /* containing the new or modified option.   */
      /*------------------------------------------*/
      $scope.$close([$scope.optionMaster]);
    };

    /*************************************************************************
     * handlePriceBlur */
    /**
     * Blur handler for the price input. Zeros out the price if it's not a
     * valid number.
     *************************************************************************/
    $scope.handlePriceBlur = function () {
      if (!Number($scope.optionMaster.priceChange))
        $scope.optionMaster.priceChange = 0;
    };

    /*************************************************************************
     * selectedOption */
    /**
     * Blur handler for the quantity input. Zeros out the quantity if it's not
     * a valid number.
     *************************************************************************/
    $scope.handleQtyBlur = function () {
      if (!Number($scope.optionMaster.qtyChange))
        $scope.optionMaster.qtyChange = 0;
    };

    /*************************************************************************
     * selectedOption */
    /**
     * Getter/setter for the option select input.
     *
     * @param   opt     Selected option
     * @return  Object  Current active option
     *************************************************************************/
    $scope.selectedOption = function (opt) {
      /*------------------------*/
      /* Getter - Return option */
      /*------------------------*/
      if (!arguments.length) return mOption;

      /*---------------------------------------*/
      /* Setter - Update option ID and values. */
      /*---------------------------------------*/
      mOption = opt;
      $scope.optionMaster.optionID = mOption.id;
      $scope.optionMaster.type = mOption.type;
      $scope.optionMaster.active = mOption.active;
      $scope.optionMaster.optionName = mOption.name;

      /*--------------------------------------------*/
      /* Enable the values dropdown input when the  */
      /* option selected has values to choose from. */
      /*--------------------------------------------*/
      $scope.enableValues = $scope.addMode
        ? mOption && mOption.values.length > 0
        : false;

      /*------------------------------------*/
      /* Enable the quantity input if the   */
      /* selection is a Master Option Type. */
      /*------------------------------------*/
      $scope.allowQtyChange =
        mOption.type != SERVER.BooksDBConstants.MOT_SELECTION_LIST;

      /*------------------------------------------------------*/
      /* Display tooltip when quantity change is not allowed. */
      /*------------------------------------------------------*/
      $scope.allowQuantityChangett =
        !$scope.allowQtyChange && $scope.showQty
          ? 'This is not available for this option.'
          : '';
    };

    /*----------------------------------------------*/
    /* Initial setup for the dialog. When modifying */
    /* an existing option, preselect the option     */
    /* from the list with the given active flag.    */
    /*----------------------------------------------*/
    if (!$scope.addMode) {
      var curOption = angular.copy(
        $scope.optionMasterList.find(function (om) {
          return om.id == $scope.optionMaster.optionID;
        })
      );
      curOption.active = $scope.optionMaster.active;
      $scope.selectedOption(curOption);
    }
  };

  /*************************************************************************
   * show */
  /**
   * Show the modal dialog for reviewing and managing Item Discounts
   * This will be used to input new Discounts or change existing Discounts.
   *
   * @param   addMode           Flag to indicate that the ItemOption being managed
   *                            will be a new object.
   * @param   optionMaster      The ItemOption object to modify. A default object
   *                            will be used if adding a new item option.
   * @param   allowPriceChange  Flag to indicate price change is allowed.
   * @param   optionMasterList  The list of available ItemOptionMaster objects
   *                            to assign from.
   * @param   showQty           Indication to show the quantity input.
   *
   * @return  Promise Object    Resolves with new/updated option object
   *************************************************************************/
  this.show = function (
    addMode,
    optionMaster,
    allowPriceChange,
    optionMasterList,
    showQty
  ) {
    return $uibModal.open({
      template: addChangeItemOptionDialogTemplate,
      size: 'md',
      backdrop: 'static',
      controller: AddChangeItemOptionDialogController,
      resolve: {
        addMode: function () {
          return addMode;
        },
        optionMaster: function () {
          return optionMaster
            ? angular.copy(optionMaster)
            : { priceChange: 0, qtyChange: 0, values: [] };
        },
        allowPriceChange: function () {
          return allowPriceChange;
        },
        optionMasterList: function () {
          return optionMasterList;
        },
        showQty: function () {
          return showQty;
        }
      }
    }).result;
  };
}
